export enum ECommentRichContentCategory {
  MENTION_USER = 1000,
}

interface ICommentRichContent {
  type: ECommentRichContentCategory;
  start: number;
  length: number;
}

export interface IMentionUserRichContent extends ICommentRichContent {
  type: ECommentRichContentCategory.MENTION_USER;
  mentionUserId: string;
}

export type TCommentRichContent = IMentionUserRichContent;
